import React, { Component } from 'react';
import withFetch from '../../hoc/withFetch';
import withAuthProvider from '../../hoc/withAuthProvider';
import Heading from '../../components/heading';
import { REACT_APP_API_BASE } from '../../config';
import CategoryNavigation from '../../components/category-navigation';
import Spinner from  '../../components/spinner';
class Categories extends Component {
    
    state = {
        isLoading: true,
        data: null
    };


    async fetchCategories() {
        const rawRes = await this.props.fetch(`${REACT_APP_API_BASE}/units/search/categories`);
  
        if (rawRes.ok) {
          return await rawRes.json();
        }
  
        return {};
    }

    async componentDidUpdate() {
        if (!this.props.isAuthenticated) return;

        if (this.state.data) return;

        const data = await this.fetchCategories();

        this.setState({
            isLoading: false,
            data
        });
    }


    render() {
        
        return (
            <section className="categories">
                <Heading heading="Utforska kategorier" />
                <CategoryNavigation categories={this.state.data} isLoading={this.state.isLoading} />
                <Spinner isLoading={this.state.isLoading} fast={true} />
            </section>
            
        );
    }
};

export default withAuthProvider(withFetch(Categories));